import $ from "jquery";

class ItemAspect {
  private aspects(): JQuery {
    return $(".aspect");
  }

  private aspectElement(): JQuery {
    return $("#aspect");
  }

  onAspectChange(f: (aspectId: string) => void): void {
    this.aspects().each((index, aspect) => {
      $(aspect).click((e) => {
        f((e.target as HTMLElement).id);
      });
    });
  }

  flipSelectedAspect(aspectId: string): void {
    const selectedElement = this.selectedAspectElement();
    if (selectedElement) {
      $(selectedElement).removeClass("selected");
    }
    const aspectElement = $(`#${aspectId}`);
    aspectElement.addClass("selected");
    const id = aspectElement.data("aspect");
    this.setAspectId(id);
  }

  setAspectId(id: string | number): void {
    this.aspectElement().val(id);
  }

  selectedAspectElement(): HTMLElement | null {
    const selected = this.aspects().filter(".selected");
    return selected.length > 0 ? selected[0] : null;
  }

  selectedAspectId(): string | number {
    const element = this.selectedAspectElement();
    return element ? $(element).data("aspect") : "";
  }
}

export { ItemAspect };
